import { api } from '../../../../api/datasource';

export const LoadCadastro = async (url) => {
  // console.log('LoadCadastro: ' + url)
  const res = await api.get(url)
  return res.data
}